module.exports = __webpack_public_path__ + "img/bottom.925f4ea4.jpg";